module.exports = __webpack_public_path__ + "img/nav_item_bg4_no_active.030b0e94.png";